import React, { FC, useRef } from 'react';

interface ITimeline {}

let startX: number;

const Timeline: FC<ITimeline> = ({}): React.ReactElement => {
    const scrollBox = useRef<any>(null);

    const mouseMoveHandler = (event: any) => {
        startX += (startX - event.pageX);
        scrollBox.current.scrollTo(startX, 0);
    };

    const mouseUpHandler = () => {
        scrollBox.current.onmousemove = function () {
            return false;
        }
    };

    const grabHandler = (event: any) => {
        event.preventDefault();
        startX = event.pageX;

        scrollBox.current.onmousemove = function (event: any) {
            mouseMoveHandler(event);
        }
    };

    return (
        <div
            className="payment-protection__scroll-box"
            ref={scrollBox}
            onMouseDown={(event) => grabHandler(event)}
            onMouseUp={() => mouseUpHandler()}
        >
            <div className="payment-protection__timeline-box">
                <div className="container">
                    <div className="payment-protection__timeline-container">
                        <time className="payment-protection__timeline-time first-circle">-10 days</time>
                        <time className="payment-protection__timeline-time">01/01/2022</time>
                        <span className="payment-protection__timeline-legend first-circle">Date of Dispatch</span>
                        <span className="payment-protection__timeline-legend">Date of invoice</span>
                        <div className="payment-protection__tooltip">
                            <span className="payment-protection__tooltip-text">10 days from dispatch</span>
                        </div>
                    </div>
                    <div className="payment-protection__timeline-container md-circle bottom">
                        <time className="payment-protection__timeline-time">02/02/2022</time>
                        <span className="payment-protection__timeline-legend">Payment Due Date</span>
                        <div className="payment-protection__tooltip mb-20">
                            <span className="payment-protection__tooltip-text">30 Days from invoice date</span>
                        </div>
                    </div>
                    <div className="payment-protection__timeline-container lg-circle">
                        <time className="payment-protection__timeline-time">01/03/2022</time>
                        <span className="payment-protection__timeline-legend middle">Expiry of Extension Stop Working</span>
                        <div className="payment-protection__tooltip">
                            <span className="payment-protection__tooltip-text">Members Collection efforts should be done here – max terms 30 days</span>
                        </div>
                    </div>
                    <div className="payment-protection__timeline-container lg-circle bottom">
                        <time className="payment-protection__timeline-time">30/03/2022</time>
                        <span className="payment-protection__timeline-legend middle">Claim payment DFA may decide to Blacklist</span>
                        <div className="payment-protection__tooltip">
                            <span className="payment-protection__tooltip-text">Members must report within this  period failing  which will result in claim being denied</span>
                        </div>
                    </div>
                    <div className="payment-protection__timeline-container md-circle double">
                        <time className="payment-protection__timeline-time">29/06/2022</time>
                        <div className="payment-protection__tooltip mb-230">
                            <span className="payment-protection__tooltip-text">DFA Review claims documents and completes claim assessment for payment</span>
                        </div>
                        <div className="payment-protection__tooltip mb-0">
                            <span className="payment-protection__tooltip-text">Final Claim disbursement happens in 90 days from complete submission of claim– reducing the overall process by 90 days</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Timeline;
